import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css";

import {
  Container,
} from "reactstrap";


function Footer() {
  return (
    <footer className=" text-black pt-2 mt-2" style={{ backgroundColor: "#dee2e6" }}> {/* Reduced padding */}
      <Container >

        <div className="row text-center">
          {/* <div className="col-md-1"></div> */}
          <div className='col-md-6' ><Link style={{ textDecoration: 'none' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} to="/contact " className="text-black"> Contact Us</Link></div>
         <div className='col-md-6'><Link style={{ textDecoration: 'none' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} to="/faq" className="text-black">FAQs</Link></div>
          {/* <div className='col-md-4' style={{ textAlign: 'right' }}><span>Contact: punjabdesk@hkcl.in  |  0172-5210290/291</span></div> */}
          {/* <div className="col-md-4 text-center col-xs-6 ">
            <h6>Useful Links</h6> 
            <ul className="list-unstyled">
              <li><Link to="/contact" className="text-black">Contact Us</Link></li>
              <li><Link to="/downloads" className="text-black">Downloads</Link></li>
              <li><Link to="/faqs" className="text-black">FAQs</Link></li>
            </ul>
          </div>
          <div className="col-md-4 text-center">

          </div>


          <div className="col-md-4 col-xs-6 text-center">
          <p>Email Id: punjabdesk@hkcl.in</p>
          <p>Phone No: 0172-5210290/291</p>
        </div> */}

        </div>
        {/* <div className='row text-center'>
          <div className='col-md-6' ><span>Email Id: punjabdesk@hkcl.in</span></div>
          <div className='col-md-6'><span>Phone No: 0172-5210290/291</span></div>
        </div> */}
        <div className='row mt-2 text-center' style={{ borderTop: "2px solid" }}>
          {/* <div className="text-center" style={{ borderTop: "2px solid" }}> */}
          <div className='col-md-6 col-xs-12' >
            <span className="" style={{ marginBottom: "0" }}>&copy; {new Date().getFullYear()} Haryana Knowledge Corporation Ltd. <a href="https://hkcl.in/" target="_blank ">(HKCL) </a></span></div>
          <div className='col-md-6 col-xs-12' ><span>Contact: hptipanchkula@gmail.com</span></div>
          {/* </div> */}
        </div>

      </Container >

    </footer >

  );
}

export default Footer;
